export var SNACKBAR_LEAVING_TRANSITION_DURATION = 200;
